export default "__VITE_PUBLIC_ASSET__4f018d7b__"